import React from 'react'
import Counter from './Counter'

const OurJourney = () => {
  return (
    <div  className='bg-our-journey h-fit lg:h-[70vh] w-full bg-cover bg-center text-[#fff] flex flex-col items-center justify-evenly py-12 lg:py-0 px-6 md:px-12' >
        <div className='flex flex-col items-center gap-2 md:w-[80%] lg:w-[50%] 3xl:w-[40%] pb-12 lg:pb-0' >
          <h1 className='text-4xl' >Join us on this <span className='text-5xl font-mosk600' >Journey</span></h1>
          <p className='md:text-center lg:text-xl font-normal' >Step into a world of innovative event solutions and let us create unforgettable experiences together. Welcome to Blue Door Event Solutions - where your vision meets our expertise.</p>
        </div>
        <div className='flex flex-wrap items-center justify-center gap-x-12 gap-y-6 lg:gap-14'>
          <span className='flex flex-col items-center lg:gap-2' >
            <span className='flex items-center gap-2 text-5xl md:text-7xl font-bebas ' >
            <Counter target={60} duration={2000} />
              <p className='p-0 m-0' >+</p>
              </span>
            <p className='text-sm ' >HAPPY <span className='text-lg lg:text-xl font-mosk600' >Clients</span></p>
          </span>
          <span className='flex flex-col items-center lg:gap-2'>
            <span className='flex items-center gap-2 text-5xl md:text-7xl font-bebas'>
            <Counter target={1200} duration={2000} />
            <p>+</p>
            </span>
            <p className='text-sm'>PROJECTS <span  className='text-lg lg:text-xl font-mosk600'>Accomplished</span></p>
          </span>
          <span className='flex flex-col items-center lg:gap-2'>
            <span className='flex items-center gap-2 text-5xl md:text-7xl font-bebas'>
              <Counter target={4} duration={1000} />
              <p>Lac+</p>
            </span>
            <p className='text-sm'>AUDIENCE <span className='text-lg lg:text-xl font-mosk600'>Entertained</span></p>
          </span>
          <span className='flex flex-col items-center lg:gap-2'>
            <span className='flex items-center gap-2 text-5xl md:text-7xl font-bebas'>
              <Counter target={21} duration={2000} />
              <p>+</p>
            </span>
            <p className='text-sm'>TEAM <span className='text-lg lg:text-xl font-mosk600'>Experience</span></p>
          </span>
          <span className='flex flex-col items-center lg:gap-2' >
            <span className='flex items-center gap-2 text-5xl md:text-7xl font-bebas'>
              <Counter target={8} duration={1000} />
            </span>
            <p className='text-sm'>YEARS <span className='text-lg lg:text-xl font-mosk600'>Evolving!</span></p>
          </span>
        </div>
    </div>
  )
}

export default OurJourney
